export function gridStandings() {
  $(".playoff__column").each(function() {
    let gf = $(this).parent(".playoff-gf");
    let prev = $(this).prev();
    let next = $(this).next();
    let current = $(this);
    let prevChild = prev.children(".playoff-card");
    let nextChild = next.children(".playoff-card");
    let currChild = current.children(".playoff-card");
    if (currChild.length / nextChild.length === 2) {
      next.addClass("playoff__column-dash");
    }
    if (currChild.length / nextChild.length === 2 && nextChild.length === 2) {
      nextChild.first().css("top", "42px");
      nextChild.last().css("top", "124px");
    }
    if (
      prevChild.length === 4 &&
      currChild.length === 2 &&
      nextChild.length === 2 &&
      currChild.length === nextChild.length
    ) {
      nextChild.first().css("top", "42px");
      nextChild.last().css("top", "124px");
    }
    if (
      current
        .siblings()
        .first()
        .children(".playoff-card").length === 8 &&
      prevChild.length === 4 &&
      currChild.length / nextChild.length === 2 &&
      nextChild.length === 1
    ) {
      currChild.first().css("top", "120px");
      currChild.last().css("top", "373px");
    }
    if (
      prevChild.length === 8 &&
      currChild.length === 4 &&
      nextChild.length === 2
    ) {
      currChild.first().css("top", "43px");
      currChild.eq(1).css("top", "124px");
      currChild.eq(2).css("top", "210px");
      currChild.last().css("top", "295px");
    }
    if (
      (nextChild.length === 0 &&
        (prevChild.length === 2 || prevChild.length === 1)) ||
      (currChild.length === nextChild.length && nextChild.length === 1)
    ) {
      current.children(".playoff-card").addClass("playoff-card-alone");
    }
    if (prevChild.length !== 0) {
      current.children(".playoff-card").addClass("dash-before");
    }
    if (nextChild.length !== 0) {
      current.children(".playoff-card").addClass("dash-after");
    }
    if (gf.length) {
      current.children(".playoff-card").addClass("gf");
    }
  });

  $(".playoff").each(function() {
    if ($(this).children(".playoff-gf").length) {
      let parent = $(this).children(".playoff-box");
      $(this)
        .children(".playoff-gf")
        .children(".playoff__column")
        .children(".playoff-card")
        .addClass("dash-before");
      const ubColCount = parent
        .children(".playoff-ub")
        .children(".playoff__column").length;
      const lbColCount = parent
        .children(".playoff-lb")
        .children(".playoff__column").length;
      for (let j = ubColCount; j < lbColCount; j++) {
        parent
          .children(".playoff-ub")
          .append(
            `<div class="playoff__column playoff__column-no-match"><div class="dash"></div></div>`
          );
      }
      $(".playoff-lb")
        .children(".playoff__column")
        .last()
        .children(".playoff-card")
        .addClass("dash-after");
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/components/tournament-brackets.js